import { emptyData } from "../state";

export const signout = async (set) => {
  set({ isLoading: true });
  localStorage.removeItem("@Auth:access");
  localStorage.removeItem("@Auth:refresh");
  set(emptyData);
  set({ isLoading: false });
};
